import type { NavSection } from '@pazportal/ui';
import { portalViewAsPickerUrl } from '../lib/portalUrl';
import { locationPath } from '../lib/locationPaths';

// Ink, matching the customer portal's sidebar / paznetworks.com header (was navy #1B3A6B).
export const PORTAL_COLOR = '#1F1E26';
export const PORTAL_NAME = 'PazNetworks, Inc.';
export const PORTAL_SUBTITLE = 'Admin Workspace';

export const navSections: NavSection[] = [
  {
    label: 'Command',
    items: [
      { label: 'Dashboard', href: '/dashboard' },
      { label: 'Command Center', href: '/command-center' },
      { label: 'Customers', href: '/customers' },
      { label: 'Revenue', href: '/revenue' },
    ],
  },
  {
    label: 'Operations',
    items: [
      { label: 'Sites', href: '/locations' },
      { label: 'Properties', href: '/properties' },
      { label: 'Devices', href: '/devices' },
      { label: 'Network operations', href: '/network-ops/map' },
      { label: 'Device Types', href: '/device-types' },
      { label: 'Tickets', href: '/tickets' },
      { label: 'Field Trips', href: '/trips' },
      { label: 'Trip Atlas', href: '/trips/atlas' },
      { label: 'Trip Runs', href: '/runs' },
      { label: 'Trip Imports', href: '/trips/imports' },
    ],
  },
  {
    label: 'Billing',
    items: [
      { label: 'Trip Billing', href: '/billing' },
      { label: 'Invoices', href: '/invoices' },
    ],
  },
  {
    label: 'Customer Access',
    items: [
      { label: 'Onboard customer', href: '/onboard' },
      { label: 'Provisioning', href: '/provisioning' },
      { label: 'Portal Access', href: '/portal-access' },
      // External: opens the customer portal's staff picker in a new tab.
      { label: 'View portal as…', href: portalViewAsPickerUrl() },
      { label: 'Zoho Sync', href: '/zoho-sync' },
    ],
  },
  {
    label: 'Integrations',
    items: [
      { label: 'Status', href: '/integrations' },
      { label: 'Auvik Tenants', href: '/integrations/auvik' },
    ],
  },
  {
    label: 'System',
    items: [
      { label: 'Audit Log', href: '/audit' },
      { label: 'Roles', href: '/roles' },
      { label: 'Database migration', href: '/network-ops/migration' },
    ],
  },
];

export function locationNavSections(locationId: string): NavSection[] {
  return [
    {
      label: 'Site',
      items: [
        { label: 'Dashboard', href: locationPath(locationId) },
        { label: 'Tickets', href: locationPath(locationId, 'tickets') },
        { label: 'Documents', href: locationPath(locationId, 'documents') },
        { label: 'Site operations', href: locationPath(locationId, 'operations') },
        { label: 'Network', href: locationPath(locationId, 'network') },
        { label: 'Racks', href: locationPath(locationId, 'racks') },
      ],
    },
    {
      label: 'Account',
      items: [
        { label: 'All sites', href: '/locations' },
        { label: 'Admin home', href: '/dashboard' },
      ],
    },
  ];
}
